import { render, staticRenderFns } from "./BroadcastPushNotification.vue?vue&type=template&id=6cb20dcd"
import script from "./BroadcastPushNotification.vue?vue&type=script&lang=js"
export * from "./BroadcastPushNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports